const getAudioUrl = (file) => {
  if (!file) return '';
  if (file instanceof File) {
    return URL.createObjectURL(file);
  }
  if (typeof file === 'string') {
    return file;
  }
  return '';
};

export { getAudioUrl };
